import { render } from "./StoryTwoUp.vue?vue&type=template&id=aa3063e8"
import script from "./StoryTwoUp.vue?vue&type=script&lang=ts"
export * from "./StoryTwoUp.vue?vue&type=script&lang=ts"

import "./StoryTwoUp.vue?vue&type=style&index=0&id=aa3063e8&lang=postcss"
script.render = render

export default script